import { render, staticRenderFns } from "./MenuBase.vue?vue&type=template&id=168e9250&"
import script from "./MenuBase.vue?vue&type=script&lang=js&"
export * from "./MenuBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports